<template>
  <v-container>
    <v-row>
      <v-col v-bind="cardFormColsProps">
        <v-card v-bind="cardProps" class="ui-module-card">
          <v-card-title v-bind="cardTitleProps" class="ui-module-titlebar">Nuevo item</v-card-title>
          <v-card-text>
            <v-form v-model="itemForm">
              <v-select
                class="ui-form-field mt-2"
                background-color="transparent"
                color="secondary"
                rounded
                filled
                dense
                :items="tiposItem"
                item-value="id"
                item-text="title"
                v-model="tipoItem"
                :rules="required"
              >
                <template v-slot:label>Tipo de item <span class="red--text">*</span> </template>
              </v-select>
              <v-text-field
                class="ui-form-field"
                v-model="itemName"
                v-bind="textInputProps"
                background-color="transparent"
                :rules="required"
              >
                <template v-slot:label>Nombre del item <span class="red--text">*</span> </template>
              </v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions v-bind="cardActionsProps" class="ui-module-actions">
            <v-btn v-bind="secondaryButtonProps" class="ui-module-btn-outline" to="/equipamiento/items">Cancelar</v-btn>
            <v-btn
              v-bind="primaryButtonProps"
              class="ui-module-btn-solid"
              :disabled="!itemForm || loading"
              v-on:click="triggerSaveItem()"
              >Registrar item</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {
  cardActionsProps,
  cardFormColsProps,
  cardProps,
  cardTitleProps,
  primaryButtonProps,
  secondaryButtonProps,
  textInputProps,
} from '../../components/props/props'

import { mapActions, mapGetters } from 'vuex'

export default {
  data() {
    return {
      cardFormColsProps,
      cardProps,
      cardTitleProps,
      cardActionsProps,
      primaryButtonProps,
      secondaryButtonProps,
      textInputProps,
      tipoItem: null,

      itemName: '',
      loading: false,
      itemForm: false,

      required: [(v) => !!v || 'Este campo es requerido.'],
    }
  },

  computed: {
    ...mapGetters('tipoItem', {
      tiposItem: 'getTiposItem',
    }),
  },

  methods: {
    ...mapActions('item', ['saveItem']),
    ...mapActions('tipoItem', ['fetchTiposItem']),

    triggerSaveItem: async function () {
      this.loading = true

      await this.saveItem({
        item: this.itemName,
        fk_idCatTipoItem: this.tipoItem,
      })

      await this.fetchTiposItem()

      this.$router.replace('/equipamiento/items')
      this.loading = false
    },
  },
}
</script>

<style scoped>
.ui-module-titlebar {
  color: #e0e0e0 !important;
  border-bottom: 1px solid rgba(255, 159, 67, 0.24) !important;
}

::v-deep .ui-module-actions .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s ease;
}

::v-deep .ui-module-actions .ui-module-btn-solid {
  background: linear-gradient(135deg, #ff9f43 0%, #ffbe76 100%) !important;
  color: #1f1305 !important;
  box-shadow: 0 8px 24px rgba(255, 159, 67, 0.28) !important;
}

::v-deep .ui-module-actions .ui-module-btn-outline {
  background: rgba(255, 159, 67, 0.08) !important;
  border: 1px solid rgba(255, 159, 67, 0.35) !important;
  color: #ffbe76 !important;
}

::v-deep .ui-module-actions .v-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 159, 67, 0.25) !important;
}

::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(255, 159, 67, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  transition: all 0.3s ease !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(255, 159, 67, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input,
::v-deep .ui-form-field .v-select__selection,
::v-deep .ui-form-field .mdi-menu-down {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label,
::v-deep .ui-form-field .v-label--active {
  color: #ffbe76 !important;
}

::v-deep .ui-form-field .v-messages__message,
::v-deep .ui-form-field .v-text-field__details {
  color: rgba(224, 224, 224, 0.55) !important;
}
</style>
